import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import "@/client";
import { readUserClientLinksWithPermissionsUserClientLinksGet } from "@/client-admin";
import { columns } from "@/components/admin/UserClientLinkTable/columns";
import { DataTable } from "@/components/admin/UserClientLinkTable/data-table";
import { LoadingComponent } from "@/components/LoadingComponent";
import { checkSuperUserPermission } from "@/lib/utils";

export const Route = createFileRoute("/_superuser/admin/user-client-links/")({
  component: UserClientLinks,
  beforeLoad: () => {
    checkSuperUserPermission("user-management");
  },
});

export const useUserClientLinks = () => {
  return useQuery({
    queryKey: ["user-client-links"],
    queryFn: () => readUserClientLinksWithPermissionsUserClientLinksGet(),
  });
};

function UserClientLinks() {
  const { data, isLoading, isError, error } = useUserClientLinks();
  if (isLoading) return <LoadingComponent />;
  if (isError) return <div>Error: {error?.message}</div>;
  return (
    <div>
      <h1>User Client Links</h1>
      <DataTable data={data?.data ?? []} columns={columns} />
    </div>
  );
}
